"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTickerDataSchema = exports.NotificationTickerItemSchema = void 0;
var zod_1 = require("zod");
exports.NotificationTickerItemSchema = zod_1.z.object({
    title: zod_1.z.string(),
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
    logMeta: zod_1.z.object({
        object: zod_1.z.string(),
        objectType: zod_1.z.string(),
        position: zod_1.z.number(),
        noticeBannerTitle: zod_1.z.string(),
        deepLinkUri: zod_1.z.string(),
    }),
});
exports.NotificationTickerDataSchema = zod_1.z.object({
    header: zod_1.z.string().optional(),
    items: zod_1.z.array(zod_1.z.object({
        header: zod_1.z.string().optional(),
        items: zod_1.z.array(exports.NotificationTickerItemSchema),
    })),
    logMeta: zod_1.z.object({
        objectContainer: zod_1.z.string(),
        widgetTitle: zod_1.z.string().optional(),
    }),
});
